(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('CountryNote', CountryNote);

    CountryNote.$inject = ['$resource'];

    function CountryNote ($resource) {
        var resourceUrl =  'api/country-notes';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
